import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import './Login.css';

export default function InviteAccept() {
  const token = window.location.pathname.split('/invite/')[1] || '';
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('Loading invite...');
  const [done, setDone] = useState(false);

  useEffect(() => {
    async function loadInvite() {
      try {
        const res = await fetch(`/api/invites/${encodeURIComponent(token)}`);
        const data = await res.json();
        if (!res.ok) {
          setMessage(data.error || 'Invite not found');
          return;
        }
        setInvite(data.invite);
        setMessage('');
      } catch (e) {
        setMessage('Unable to load invite.');
      }
    }
    loadInvite();
  }, [token]);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) {
      setMessage('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setMessage('Password confirmation does not match.');
      return;
    }
    setMessage('Completing registration...');
    const res = await fetch(`/api/invites/${encodeURIComponent(token)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    const data = await res.json();
    if (!res.ok) {
      setMessage(data.error || 'Unable to complete invite.');
      return;
    }
    setDone(true);
    setMessage('Registration completed. You can now log in.');
  }

  return <div className="login-container">
    <div className="login-card invite-card">
      <div className="login-header">
        <div className="shield-icon-container"><ShieldCheck size={46} className="shield-icon" /></div>
        <h1>SEO Central Invite</h1>
        <p>{invite?.email || 'Member registration'}</p>
      </div>
      {message && <div className="login-error"><span>{message}</span></div>}
      {invite && !done && <form onSubmit={submit} className="login-form">
        <div className="input-group">
          <label>Email</label>
          <input className="cyber-input" value={invite.email} disabled />
        </div>
        <div className="input-group">
          <label>Create Password</label>
          <input className="cyber-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Minimum 8 characters" required />
        </div>
        <div className="input-group">
          <label>Confirm Password</label>
          <input className="cyber-input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
        </div>
        <button type="submit" className="cyber-button">Complete Registration</button>
      </form>}
      {done && <a className="cyber-button invite-login-link" href="/">Go to Login</a>}
    </div>
    <div className="cyber-grid-overlay"></div>
  </div>;
}
